<template>
	<button
		class="bg-orange-600 text-white hover:bg-orange-800 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
	>
		<slot />
	</button>
</template>
